import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { MODULE_NAME as PERFORMANCE_RULES_MODULE } from 'modules/performance-rules/config/routes';
import columnDefinitions from './columnDefinitions';
import { PERFORMANCE_RULES_REPORT_ID } from './performanceRulesReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const performanceRulesReportConfig = {
    id: PERFORMANCE_RULES_REPORT_ID,
    label: 'Performance Rules',
    module: PERFORMANCE_RULES_MODULE,
    endpoint: 'performance-rules',
    rowIdField: FIELDS.PERFORMANCE_RULE_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    searchPlaceholderMsgId: 'performance.rules.report.search.placeholder',
    searchField: FIELDS.PERFORMANCE_RULE_NAME.field,
    filters: [],
    initialFilters: [],
};
